import { RootState } from '@app/redux/root-reducer';

export const selectRecommendations = (state: RootState) => state.homeReducer.recommendations;

export const selectNewRecipes= (state: RootState) => state.homeReducer.newRecipes;